const prefix = 'fas';
const iconName = 'folder';
const width = 512;
const height = 512;
const aliases = [128447, 61716, 128193, 'folder-blank'];
const unicode = 'f07b';
const svgPathData = 'M512 144v288c0 26.5-21.5 48-48 48h-416C21.5 480 0 458.5 0 432v-352C0 53.5 21.5 32 48 32h160l64 64h192C490.5 96 512 117.5 512 144z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
